{
  "locale": "fr-CA",
  "global": {
    "site-name": "Projet Habitation",
    "logo": "projethabitation.svg"
  },
  "components": {
    "cookie-consent": {
      "title": "Consentement aux cookies",
      "disclaimer": "Ce site utilise des cookies pour personnaliser le contenu et analyser le trafic web.",
      "learn-more": "En savoir plus.",
      "accept": "Accepter",
      "customize": "Personnaliser",
      "manage": "Gérer les cookies",
      "preferences": {
        "title": "Préférences de cookies",
        "intro": "Choisissez les catégories de cookies que vous souhaitez autoriser. Votre choix est enregistré sur cet appareil et peut être modifié à tout moment.",
        "close": "Fermer",
        "always-active": "Toujours actifs",
        "necessary": {
          "name": "Cookies nécessaires",
          "description": "Indispensables au fonctionnement du site, notamment à la navigation et à l'enregistrement de vos préférences. Ils ne peuvent pas être désactivés."
        },
        "analytics": {
          "name": "Cookies d'analyse",
          "description": "Nous aident à comprendre comment le site est utilisé afin d'en améliorer la performance et le contenu."
        },
        "marketing": {
          "name": "Cookies de marketing",
          "description": "Servent à mesurer l'efficacité de nos campagnes et à vous présenter des publicités pertinentes."
        },
        "accept-all": "Tout accepter",
        "reject-all": "Tout refuser",
        "save": "Enregistrer mes choix"
      }
    },
    "language-switcher": {
      "title": "Project New Home",
      "content": "English"
    },
    "new-projects": {
      "header": "Projets en vedette",
      "scroll-left": "Défiler vers la gauche",
      "scroll-right": "Défiler vers la droite"
    },
    "phone-button": {
      "phone": "Appelez",
      "phone-with-name": "Appelez {name}"
    },
    "more-results-button": {
      "text": "Voir plus de résultats"
    },
    "website-button": {
      "website": "Visitez le site Web"
    },
    "range": {
      "to": "à",
      "unlimited": "Illimité"
    },
    "ad-unit": {
      "advertisement": "Publicité"
    },
    "subscribe": {
      "title": "Recevez les alertes nouveautés",
      "banner-title": "Soyez informé dès qu'un nouveau projet est publié dans ce secteur.",
      "email": "Courriel",
      "email-placeholder": "Courriel",
      "button": "M'inscrire",
      "privacy-consent": "En vous inscrivant, vous acceptez de recevoir nos infolettres, conformément à notre ",
      "privacy-policy": "politique de protection de la vie privée",
      "success": "Inscription réussie!",
      "error": "Une erreur de serveur s’est produite. Veuillez réessayer plus tard.",
      "location-error": "La zone d’abonnement n’a pas pu être préparée. Veuillez recharger la page et réessayer.",
      "email-sent": "Un courriel vous a été envoyé."
    },
    "turnstile-modal": {
      "title": "Vérifiez que vous êtes humain",
      "description": "Veuillez compléter la vérification pour vous abonner à notre infolettre."
    },
    "contact-form": {
      "header": "Contactez-nous",
      "subheader": "Le constructeur vous répond rapidement, sans engagement.",
      "name": {
        "label": "Nom",
        "placeholder": "Votre nom"
      },
      "email": {
        "label": "Courriel",
        "placeholder": "nom{'@'}domaine.com"
      },
      "telephone": {
        "label": "Téléphone",
        "placeholder": "514 555-1234"
      },
      "message": {
        "label": "Message",
        "placeholder": "Bonjour, je suis intéressé à recevoir plus de détails, merci de me contacter!"
      },
      "callback": {
        "label": "Rappel",
        "asap": "Dès que possible",
        "tomorrow": "Demain",
        "this-week": "Cette semaine"
      },
      "preference": {
        "label": "Préférence",
        "anytime": "N'importe quand",
        "morning": "Matin",
        "day": "Jour",
        "night": "Soir"
      },
      "subscribe": {
        "consent": "Je veux m'abonner",
        "subject": "aux nouveautés!"
      },
      "send": "Envoyer",
      "send-request": "Obtenir plus d'informations",
      "validation": {
        "name-required": "Le nom est requis.",
        "email-required": "Le courriel est requis.",
        "email-invalid": "Le courriel est invalide.",
        "telephone-invalid": "Le téléphone est invalide.",
        "captcha-failed": "Validation humaine échouée."
      },
      "privacy-consent": "En soumettant ce formulaire, j'accepte le traitement de mes données personnelles conformément à votre ",
      "privacy-policy": "politique de protection de la vie privée",
      "success-message": "Votre message a été envoyé!",
      "error": "Une erreur serveur inattendue s'est produite, veuillez réessayer plus tard."
    },
    "project-badge": {
      "new": "Nouvelle inscription!",
      "sold": "Vendu!"
    }
  },
  "views": {
    "home": {
      "title": "@:global.site-name {'|'} Maisons neuves & condos neufs",
      "meta": {
        "description": "Répertoire de maisons neuves et condos neufs à vendre partout au Québec. Projet Habitation vous offre les projets immobiliers de l'heure."
      },
      "hero": {
        "project-image": "Image du projet : {name}",
        "quick-links": "Liens rapides"
      },
      "pathways": {
        "header": "Que recherchez-vous?",
        "projects": {
          "title": "Un projet immobilier",
          "description": "Parcourez tous les projets d'habitation neuve au Québec",
          "action": "Voir les projets"
        },
        "builders": {
          "title": "Un constructeur",
          "description": "Découvrez les constructeurs et leurs réalisations partout au Québec",
          "action": "Voir les constructeurs"
        },
        "assistance": {
          "title": "Un service d'aide à la recherche",
          "description": "Décrivez ce que vous cherchez et notre équipe s'en occupe gratuitement",
          "action": "Faire une demande"
        },
        "guides": {
          "title": "Guides et conseils",
          "description": "Taxes, financement, types d'habitations : tout pour acheter neuf",
          "action": "Lire les guides"
        }
      },
      "explore": {
        "regions": {
          "header": "Explorer par région",
          "other": "Autres",
          "show-cities": "Afficher les {count} villes",
          "show-fewer-cities": "Afficher moins",
          "view-all": "Voir le projet : {name} | Voir le projet : {name} | Voir les {count} projets : {name}"
        }
      },
      "featured": {
        "header": "Découvrez nos projets vedettes"
      }
    },
    "search": {
      "title": "{header} {'|'} @:global.site-name",
      "results": {
        "header": {
          "results": "Résultats",
          "distance": "Rayon",
          "of-city": "de {name}",
          "of-region": "de la région {genitiveName}",
          "region-genitive-default": "de {name}",
          "of-location": "de {name}"
        },
        "no-results": "Votre recherche n'a donné aucun résultat. Ajustez vos filtres pour trouver ce que vous cherchez.",
        "no-results-in-location": "Aucun projet ne correspond à votre recherche à cet endroit. Voici les projets les plus proches.",
        "nearby": {
          "subject": "Projets",
          "subject-of-categories": "Projets de {categories}",
          "header": "{subject} à proximité de {name}",
          "header-of-region": "{subject} à proximité de la région {genitiveName}",
          "loading": "Chargement des projets...",
          "load-more": "Voir plus de projets"
        },
        "starting-from": "À partir de",
        "per-month": "par mois",
        "studio": "Studio",
        "upon-request": "Prix sur demande",
        "pagination": {
          "previous": "Précédente",
          "next": "Suivante"
        }
      },
      "placeholder": "Recherchez une ville, une région, un projet ou un constructeur",
      "placeholder-short": "Ville, région, projet ou constructeur",
      "price": "Prix",
      "for-sale": "À vendre",
      "for-rent": "À louer",
      "categories": "Catégories",
      "filters": "Filtres",
      "bedrooms": "Chambres",
      "studio-option": "Loft/Studio",
      "bathrooms": "Salles de bains",
      "button": "Rechercher",
      "sections": {
        "locations": "Lieux",
        "projects": "Projets",
        "builders": "Constructeurs"
      },
      "near-me": {
        "label": "Utiliser ma position",
        "description": "Afficher d'abord les suggestions près de chez vous"
      },
      "pills": {
        "for-sale": "À vendre",
        "for-rent": "À louer",
        "price-min-pill": "Prix ≥ {value}",
        "price-max-pill": "Prix ≤ {value}",
        "bedrooms-min-pill": "Chambres ≥ {value}",
        "bedrooms-max-pill": "Chambres ≤ {value}",
        "bedrooms-studio-pill": "Loft/Studio seulement",
        "bathrooms-min-pill": "Salles de bain ≥ {value}",
        "bathrooms-max-pill": "Salles de bain ≤ {value}",
        "clear-all": "Tout effacer"
      }
    },
    "project": {
      "title": "{header} {'|'} @:global.site-name",
      "meta": {
        "title": "{name} {'|'} {propertyType} {priceType}",
        "title-in-location": "{name} {'|'} {propertyType} {priceType} à {location}"
      },
      "price-types": {
        "for-sale": "à vendre",
        "for-rent": "à louer"
      },
      "property-types": {
        "houses": "Maisons neuves",
        "condos": "Condos neufs",
        "multiplexes": "Multiplex neufs",
        "manufactured-houses": "Maisons usinées",
        "lands": "Terrains",
        "senior-residences": "Résidences pour personnes âgées"
      },
      "breadcrumbs": {
        "home": "Accueil",
        "return": "Retourner aux résultats de recherche"
      },
      "share": {
        "share": "Partager",
        "facebook": "Facebook",
        "linked-in": "LinkedIn",
        "x": "X",
        "whatsapp": "Whatsapp",
        "email": "Courriel",
        "copy-link": "Copier le lien",
        "print": "Imprimer"
      },
      "carousel": {
        "previous": "Image précédente",
        "next": "Image suivante",
        "project": "Projet"
      },
      "stats": {
        "starting-price": "Prix de départ",
        "bedrooms": "Chambres",
        "bathrooms": "Salles de bain",
        "floor-area": "Superficie",
        "loft-studio": "Loft/Studio",
        "range": "{min} à {max}",
        "upon-request": "Sur demande"
      },
      "anchors": {
        "label": "Sections de la page",
        "overview": "Infos générales",
        "models": "Modèles",
        "details": "Détails",
        "map": "Emplacement",
        "builder": "Constructeur"
      },
      "action-bar": {
        "contact": "Obtenir plus d'informations",
        "call": "Appeler",
        "starting-at": "Dès {price}"
      },
      "models": {
        "header": "Modèles disponibles",
        "sort": "Trier",
        "sort-default": "Ordre suggéré",
        "sort-price-ascending": "Prix croissant",
        "sort-price-descending": "Prix décroissant",
        "sort-bedrooms": "Chambres",
        "sort-floor-area": "Superficie",
        "studio": "Studio",
        "sold": "Vendu",
        "starting-from": "À partir de",
        "per-month": "par mois",
        "per-month-short": "/ mois",
        "upon-request": "Prix sur demande",
        "taxes-included": "(taxes incluses)",
        "taxes-excluded": "(taxes exclues)",
        "price-disclaimer": "Les prix sont sujets à changement sans préavis."
      },
      "model-dialog": {
        "close": "Fermer",
        "contact": "Demander de l'information"
      },
      "characteristics": {
        "header": "Caractéristiques",
        "bedrooms": "Aucune chambre | 1 chambre | {count} chambres",
        "loft-studio": "Loft/Studio",
        "bedrooms-range": "{min} à {max} chambre | {min} à {max} chambres",
        "bathrooms": "Aucune salle de bain | 1 salle de bain | {count} salles de bain",
        "half-bathrooms": "Aucune salle d'eau | 1 salle d'eau | {count} salles d'eau",
        "floor-area": "pi²"
      },
      "description": {
        "header": "Description",
        "document": "Visionner le document",
        "multimedia": "Voir la présentation multimedia",
        "show-more": "Voir plus",
        "show-less": "Voir moins"
      },
      "contact": {
        "header": "Projet",
        "form-header": "En savoir plus sur ce projet",
        "website-link": "Visitez le site Web du projet"
      },
      "calculator": {
        "header": "Calculateur de prêt hypothécaire",
        "purchase-price": "Prix d'achat ($)",
        "down-payment": "Acompte ($)",
        "interest-rate": "Taux d'intérêt (%)",
        "amortization": "Amortissement (années)",
        "term": "Durée (années)",
        "payment-frequency": "Fréquence de paiement",
        "mortgage-amount": "Montant du prêt hypothécaire",
        "payments": "Paiements",
        "years": "0 ans | {count} an | {count} ans",
        "weekly": "Hebdomadaire",
        "bi-weekly": "Bimensuel",
        "monthly": "Mensuel",
        "weekly-suffix": "par semaine",
        "bi-weekly-suffix": "aux deux semaines",
        "monthly-suffix": "par mois",
        "legal-notice": "Avis légal",
        "legal": "Cet outil en ligne vous aide à estimer vos versements hypothécaires selon les données saisies. Les résultats sont à titre informatif seulement et peuvent varier selon votre situation financière. Les calculs supposent un taux d'intérêt constant et n'incluent pas les primes d'assurance prêt hypothécaire, exigée si la mise de fonds est inférieure à 20 %. Veuillez consulter votre prêteur pour des conseils personnalisés."
      },
      "builder-projects": {
        "header": "Autres projets de {builder}",
        "scroll-left": "Défiler vers la gauche",
        "scroll-right": "Défiler vers la droite"
      },
      "nearby-projects": {
        "header": "Autres projets à proximité",
        "scroll-left": "Défiler vers la gauche",
        "scroll-right": "Défiler vers la droite"
      },
      "articles": {
        "header": "Articles en lien avec {name}",
        "all": "Tous les articles de {builder} ({count})"
      }
    },
    "directory": {
      "title": "Répertoire {'|'} @:global.site-name",
      "header": "Répertoire",
      "no-results": "Aucun résultat trouvé."
    },
    "builder": {
      "title": "{subject} {'|'} @:global.site-name",
      "subject": "{name}, {category}",
      "subject-in-city": "{name}, {category} à {city}",
      "subject-in-city-region": "{name}, {category} à {city}, {region}",
      "subject-in-region": "{name}, {category} en {region}",
      "meta": {
        "description": "{subject}. Découvrez ses projets de construction neuve au Québec.",
        "description-with-summary": "{subject}. {summary}"
      },
      "breadcrumb": {
        "home": "Accueil",
        "directory": "Répertoire"
      },
      "about": "À propos",
      "articles": "Articles en lien avec {name}",
      "projects": "Projets",
      "rbq-license": "Licence RBQ {license}",
      "contact-details": "Coordonnées",
      "contact": "Contact : {name}",
      "see-active-builders": "Voir les constructeurs actifs par région"
    },
    "article": {
      "title": "{title} {'|'} @:global.site-name",
      "breadcrumb": {
        "directory": "Répertoire"
      },
      "published-on": "Publié le {date}",
      "sponsored": "En collaboration avec {builder}",
      "other-articles": "Autres articles de {builder}",
      "contact-header": "En savoir plus sur {project}",
      "contact-button": "Obtenir plus d'informations",
      "projects": "Projet mentionné | Projets mentionnés",
      "builder": "Le constructeur",
      "builder-link": "Voir la fiche de {builder}",
      "breadcrumb-home": "Accueil",
      "revised-on": "Mis à jour le {date}",
      "by": "Par {author}",
      "by-team": "Par l'équipe {site}",
      "reading-time": "{minutes} min de lecture",
      "summary": "En bref",
      "toc": "Sommaire",
      "share": "Partager",
      "share-facebook": "Partager sur Facebook",
      "share-linkedin": "Partager sur LinkedIn",
      "share-email": "Partager par courriel",
      "share-copy": "Copier le lien",
      "share-copied": "Lien copié",
      "share-native": "Plus d'options de partage",
      "toc-rail": "Dans ce guide",
      "toc-remaining": "Environ {minutes} min restante | Environ {minutes} min restantes",
      "toc-sections": "{count} section | {count} sections",
      "toc-progress": "Section {current} sur {total}",
      "faq": "Questions fréquentes",
      "sources": "Sources ({count})",
      "author-guides": "Voir ses guides",
      "guide-projects": "Projets",
      "guide-projects-button": "Voir le projet | Voir les {count} projets",
      "other-guides": "Autres guides"
    },
    "guides": {
      "title": "Guides et conseils {'|'} @:global.site-name",
      "header": "Guides et conseils",
      "intro": "Des réponses claires pour acheter ou faire construire une propriété neuve au Québec : types d'habitations, taxes, financement et garanties.",
      "featured": "À la une",
      "latest": "Derniers guides",
      "categories": "Catégories",
      "no-guides": "Aucun guide publié pour le moment.",
      "find-project": {
        "title": "Trouver un projet",
        "text": "Parcourez les projets d'habitation neuve partout au Québec.",
        "button": "Voir les projets"
      },
      "category": {
        "title": "{title} {'|'} @:global.site-name",
        "guides": "{count} guide | {count} guides",
        "projects": "Voir les projets"
      },
      "author": {
        "title": "{name}, {jobTitle} {'|'} @:global.site-name",
        "title-without-job": "{name} {'|'} @:global.site-name",
        "description": "Guides et conseils rédigés par {name} pour {site}.",
        "job": "{jobTitle} · {site}",
        "profile": "Voir son profil",
        "guides": "Guides de {name}"
      },
      "related": {
        "header": "Guides en lien",
        "all": "Tous les guides"
      }
    },
    "about": {
      "title": "À propos {'|'} @:global.site-name"
    },
    "advertise": {
      "title": "Affichez-vous {'|'} @:global.site-name",
      "header": "Faites connaître votre projet avec Projet Habitation"
    },
    "privacy": {
      "title": "Politique de protection de la vie privée {'|'} @:global.site-name"
    },
    "support": {
      "title": "Soutien {'|'} @:global.site-name",
      "header": "Besoin d'aide ou avez-vous des suggestions?"
    },
    "terms": {
      "title": "Politique d'utilisation {'|'} @:global.site-name"
    },
    "profile": {
      "confirmation-banner": {
        "message": "Votre abonnement à « {subscription} » a été confirmé.",
        "subscriptions": {
          "Newsletters": "Infolettres",
          "NewListingAlerts": "Alertes nouveautés"
        }
      }
    },
    "profile-login": {
      "title": "Connexion au profil {'|'} @:global.site-name",
      "meta": {
        "description": "Ouverture sécurisée de votre profil..."
      },
      "header": "Ouverture de votre profil",
      "message": "Veuillez patienter pendant que nous validons votre lien sécurisé."
    },
    "profile-login-error": {
      "title": "Erreur de lien de profil {'|'} @:global.site-name",
      "meta": {
        "description": "Votre lien sécurisé de profil n'a pas pu être validé."
      },
      "eyebrow": "Profil",
      "header": "Votre lien sécurisé est invalide ou expiré",
      "message": "Ouvrez à nouveau le dernier lien reçu par courriel, ou contactez le soutien si le problème persiste.",
      "home-link": "Aller à l'accueil",
      "support-link": "Contacter le soutien"
    },
    "subscriptions": {
      "title": "Abonnements {'|'} @:global.site-name",
      "meta": {
        "description": "Gérez vos préférences d'abonnement Projet Habitation."
      },
      "eyebrow": "Profil",
      "header": "Gérez vos abonnements",
      "message": "Contrôlez vos infolettres et vos alertes nouveautés à partir de ce profil sécurisé.",
      "loading": "Chargement de votre profil d'abonnement...",
      "saving": "Enregistrement...",
      "removing": "Suppression...",
      "saved": "Vos changements ont été enregistrés.",
      "errors": {
        "generic": "Nous n'avons pas pu mettre à jour vos abonnements. Veuillez réessayer."
      },
      "newsletter": {
        "title": "Infolettres",
        "description": "Recevez occasionnellement nos infolettres et des offres pertinentes de nos partenaires.",
        "enable": "Activer les infolettres",
        "disable": "Désactiver les infolettres",
        "disable-confirm": "Voulez-vous vraiment arrêter de recevoir les infolettres à cette adresse courriel?"
      },
      "unsubscribe-all": {
        "title": "Se désabonner",
        "description": "Désactivez les infolettres et toutes les alertes nouveautés.",
        "button": "Se désabonner de tout",
        "cancel": "Annuler",
        "confirm": "Voulez-vous vraiment vous désabonner des infolettres et de toutes les alertes de nouvelles inscriptions?",
        "saved": "Vous avez été désabonné de tous les abonnements."
      },
      "alerts": {
        "title": "Alertes nouveautés",
        "description": "Dites-nous où chercher, et nous vous aviserons dès que de nouvelles inscriptions seront publiées.",
        "add": "Ajouter une alerte",
        "empty": "Vous n'avez pas encore d'alertes nouveautés.",
        "item-title": "Alertes pour {name}",
        "summary-title": "Alertes pour {name} dans un rayon de {distance}",
        "summary-title-with-categories": "Alertes pour {categoriesList} à {name} dans un rayon de {distance}",
        "location-fallback": "l'emplacement sélectionné",
        "map-title": "Emplacement",
        "map-help": "Déplacez le marqueur ou cliquez sur la carte pour choisir le centre de cette alerte.",
        "distance": "Distance",
        "distance-help": "Choisissez la distance à surveiller autour de l'emplacement sélectionné.",
        "distance-option": "{distance} km",
        "categories": "Catégories",
        "categories-help": "Sélectionnez une ou plusieurs catégories pour préciser cette alerte.",
        "categories-list-conjunction": "et",
        "edit": "Modifier l'alerte",
        "save": "Enregistrer l'alerte",
        "remove": "Supprimer l'alerte",
        "remove-title": "Supprimer l'alerte pour {name}",
        "remove-confirm": "Voulez-vous vraiment supprimer cette alerte de nouvelles inscriptions?"
      },
      "map": {
        "error": "La carte n'a pas pu être chargée. Veuillez réessayer plus tard."
      }
    },
    "not-found": {
      "title": "Page introuvable {'|'} @:global.site-name",
      "header": "Cette page est introuvable...",
      "message": "La page à laquelle vous tentez d'accéder est introuvable.",
      "redirect-message": "Redirection vers la page d'accueil dans {seconds} secondes.",
      "home-link": "Retourner à l'accueil maintenant"
    },
    "editorial": {
      "title": "Éditorial {'|'} @:global.site-name",
      "header": "Éditorial",
      "intro": "Explorez les projets de construction au Québec, par type de propriété et par région.",
      "meta": {
        "description": "Découvrez notre contenu éditorial couvrant des sujets sur les projets de construction neufs, les tendances immobilières et les perspectives du marché de l'habitation."
      },
      "no-categories": "Aucune catégorie éditoriale disponible pour le moment.",
      "category": {
        "title": "{title} {'|'} @:global.site-name",
        "locations": "{title} par région",
        "advantages": "Les avantages des {title}"
      },
      "no-locations": "Aucun emplacements éditorial disponible pour le moment.",
      "location": {
        "title": "{title} {'|'} @:global.site-name",
        "child-locations": "{title} par ville",
        "choose-city": "Choisir une ville",
        "advantages": "Les avantages des {title}",
        "view-builders": "Voir les constructeurs {locationPhrase}",
        "view-builders-generic": "Voir les constructeurs",
        "laval": {
          "intro": {
            "p1-stats": "@:global.site-name regroupe actuellement {count} projets de maisons neuves en vente à Laval, dans des secteurs comme Duvernay, Auteuil, Sainte-Dorothée et Chomedey, à partir de {minPrice}.",
            "p1": "@:global.site-name regroupe des projets de maisons neuves en vente à Laval, dans des secteurs comme Duvernay, Auteuil, Sainte-Dorothée et Chomedey.",
            "p2": "Cette page présente les projets actifs publiés sur notre portail par les constructeurs, avec leurs modèles et leurs prix, mis à jour en continu."
          },
          "price": {
            "header": "Combien coûte une maison neuve à Laval?",
            "p1-stats": "Le prix des maisons neuves à vendre à Laval débute à partir de {minPrice} pour les projets répertoriés sur notre portail. Le prix final varie selon le secteur, la superficie du terrain, le modèle choisi et les inclusions offertes par le constructeur.",
            "p1": "Le prix d'une maison neuve à Laval varie selon le secteur, la superficie du terrain, le modèle choisi et les inclusions offertes par le constructeur.",
            "p2": "Les prix affichés par les constructeurs excluent souvent les taxes de vente (TPS et TVQ), qui s'appliquent aux propriétés neuves. Un remboursement partiel de ces taxes peut s'appliquer selon le prix de la maison : informez-vous auprès du constructeur avant de signer."
          },
          "sectors": {
            "header": "Dans quels secteurs de Laval trouver une maison neuve?",
            "intro": "Les projets de maisons neuves se concentrent dans quelques secteurs de Laval, chacun avec son caractère propre.",
            "duvernay": "{link} borde la rivière des Prairies dans l'est de Laval et profite d'un accès direct à l'autoroute 25 vers Montréal.",
            "sainte-dorothee": "{link}, dans l'ouest de l'île, attire les familles avec ses développements récents près de l'autoroute 13.",
            "auteuil": "{link}, au nord, offre des terrains plus généreux dans un cadre résidentiel calme.",
            "chomedey": "{link} regroupe les grands pôles commerciaux de Laval, dont le Carrefour Laval et le Centropolis."
          },
          "why": {
            "header": "Pourquoi acheter une maison neuve à Laval?",
            "p1": "Choisir une maison neuve à Laval, c'est acheter une propriété jamais habitée, construite selon les normes actuelles d'isolation et d'efficacité énergétique, dans une ville qui combine services urbains et quartiers résidentiels établis.",
            "warranty": "Une protection obligatoire : la Garantie de construction résidentielle (GCR) protège vos acomptes et couvre les malfaçons et certains vices pendant plusieurs années après la livraison.",
            "location": "Une position stratégique entre Montréal et la Rive-Nord, desservie par les autoroutes 13, 15, 19, 25 et 440.",
            "transport": "Trois stations de métro (Cartier, De la Concorde et Montmorency) et des gares de train de banlieue pour rejoindre Montréal sans voiture.",
            "lifestyle": "Des écoles, des parcs comme le Centre de la nature et des pôles commerciaux dont le Carrefour Laval, à quelques minutes des quartiers résidentiels.",
            "p2": "Un projet neuf permet aussi de personnaliser les finitions selon la phase de construction et de réduire les rénovations à prévoir pendant les premières années."
          },
          "faq": {
            "header": "Questions fréquentes sur les maisons neuves à Laval",
            "types": {
              "question": "Quels types de maisons neuves trouve-t-on à Laval?",
              "answer": "On y trouve des bungalows, des cottages, des maisons jumelées, des maisons de ville, des maisons bigénérationnelles et des maisons usinées. Utilisez le filtre par type en haut de la page pour affiner la liste des projets."
            },
            "warranty": {
              "question": "Quelle garantie protège l'achat d'une maison neuve au Québec?",
              "answer": "La Garantie de construction résidentielle (GCR) est obligatoire pour les maisons neuves vendues par un entrepreneur au Québec. Elle protège notamment vos acomptes et couvre les malfaçons et certains vices pendant plusieurs années après la réception de la maison."
            },
            "taxes": {
              "question": "Les taxes sont-elles incluses dans le prix affiché?",
              "answer": "Rarement. Les prix des maisons neuves sont généralement affichés avant les taxes de vente (TPS et TVQ). Un remboursement partiel de ces taxes peut s'appliquer selon le prix de la propriété : validez le montant final avec le constructeur."
            },
            "delivery": {
              "question": "Quel est le délai de livraison d'une maison neuve à Laval?",
              "answer": "Le délai dépend de l'avancement du projet : une maison déjà construite peut être livrée en quelques semaines, alors qu'une construction sur plan demande généralement de plusieurs mois à plus d'un an. Chaque fiche de projet indique comment joindre le constructeur pour connaître les délais réels."
            }
          }
        }
      },
      "statistics": {
        "header": "{title} : les chiffres du marché",
        "summary": "{title} : {projects}, {builders}.",
        "summary-projects": "aucun projet répertorié | {count} projet répertorié | {count} projets répertoriés",
        "summary-builders": "aucun constructeur | proposé par {count} constructeur | proposés par {count} constructeurs",
        "summary-types": "Prix affichés par les constructeurs : {types}.",
        "summary-type-entry": "{name} à partir de {price}",
        "summary-bedrooms": "Selon le nombre de chambres : {bedrooms}.",
        "summary-bedroom-entry": "{n} chambre à partir de {price} | {n} chambre à partir de {price} | {n} chambres à partir de {price}",
        "summary-studio-entry": "Loft/Studio à partir de {price}",
        "summary-amenities": "Équipements les plus répandus : {amenities}.",
        "summary-amenity-entry": "{name} dans aucun projet | {name} dans {count} projet | {name} dans {count} projets",
        "summary-updated": "Mis à jour en {date}.",
        "tables-toggle": "Voir les tableaux comparatifs",
        "types-table": {
          "header": "Prix par type de propriété",
          "type": "Type",
          "projects": "Projets",
          "bedrooms": "Chambres",
          "price-range": "Fourchette de prix",
          "floor-area": "Superficie",
          "price-per-square-foot": "Prix médian au pi²",
          "floor-area-value": "{median} pi²",
          "range": "{minimum} à {maximum}"
        },
        "lots-table": {
          "header": "Terrains",
          "type": "Type",
          "projects": "Projets",
          "price-range": "Fourchette de prix",
          "floor-area": "Superficie du terrain",
          "price-per-square-foot": "Prix médian au pi² de terrain"
        },
        "projects-table": {
          "header": "Projets répertoriés",
          "caption": "Sélection de projets répertoriés sur {siteName}, dans le même ordre que la liste plus haut.",
          "project": "Projet",
          "type": "Type",
          "bedrooms": "Chambres",
          "bathrooms": "Salles de bain",
          "floor-area": "Superficie",
          "starting-price": "À partir de",
          "bedroom-column": "aucune chambre | {n} chambre | {n} chambres",
          "builder": "Constructeur"
        },
        "faq": {
          "header": "Questions fréquentes sur les propriétés neuves {locationPhrase}",
          "header-generic": "Questions fréquentes sur les propriétés neuves",
          "types": {
            "question": "Quels types de propriétés neuves trouve-t-on {locationPhrase}?",
            "question-generic": "Quels types de propriétés neuves trouve-t-on ici?",
            "answer": "Les projets répertoriés proposent actuellement : {types}. Utilisez le filtre par type en haut de la page pour affiner la liste des projets."
          },
          "warranty": {
            "question": "Quelle garantie protège l'achat d'une propriété neuve au Québec?",
            "answer": "La Garantie de construction résidentielle (GCR) est obligatoire pour les habitations neuves vendues par un entrepreneur au Québec. Elle protège notamment vos acomptes et couvre les malfaçons et certains vices pendant plusieurs années après la réception de la propriété."
          },
          "taxes": {
            "question": "Les taxes sont-elles incluses dans les prix affichés?",
            "answer": "Rarement. Les prix des propriétés neuves sont généralement affichés avant les taxes de vente (TPS et TVQ). Un remboursement partiel de ces taxes peut s'appliquer selon le prix de la propriété : validez le montant final avec le constructeur."
          },
          "delivery": {
            "question": "Quel est le délai de livraison d'une propriété neuve {locationPhrase}?",
            "question-generic": "Quel est le délai de livraison d'une propriété neuve?",
            "answer": "Le délai dépend de l'avancement du projet : une propriété déjà construite peut être livrée en quelques semaines, alors qu'une construction sur plan demande généralement de plusieurs mois à plus d'un an. Chaque fiche de projet indique comment joindre le constructeur pour connaître les délais réels."
          }
        },
        "sources": "Prix affichés par les constructeurs, généralement avant taxes (TPS et TVQ) ; le prix au pied carré est calculé sur les prix hors taxes seulement. Sources externes : {gcr} et {revenuQuebec}.",
        "sources-gcr": "Garantie de construction résidentielle (GCR)",
        "sources-revenu-quebec": "Revenu Québec"
      },
      "map": {
        "show": "Afficher la carte",
        "hide": "Afficher la liste",
        "view-project": "Voir le projet",
        "pending-address": "Adresse à déterminer",
        "pending-address-description": "Ces projets ne sont pas encore situés précisément sur la carte.",
        "error": "La carte n'a pas pu être chargée."
      },
      "breadcrumb": {
        "home": "Accueil",
        "editorial": "Éditorial"
      },
      "view-regions": "Voir les régions",
      "view-projects": "Voir les projets",
      "view": "Voir {title}",
      "no-image": "Aucune image",
      "search-results": {
        "header": "Projets de {title}",
        "loading": "Chargement des projets...",
        "load-more": "Voir plus de projets",
        "no-results": "Aucun projet trouvé pour {title} pour le moment.",
        "filter-label": "Filtrer par type",
        "filter-clear": "Tout afficher",
        "default": "Projets"
      },
      "nearby-search-results": {
        "loading": "Chargement des projets dans les environs...",
        "no-results": "Aucun autre projet trouvé dans les environs pour {title} pour le moment.",
        "title": "Autres projets dans les environs"
      },
      "help-widget": {
        "title": "Nous pouvons quand même vous aider à trouver ce que vous cherchez",
        "description": "Aucun projet ne correspond ici, mais notre équipe peut chercher pour vous parmi des projets qui ne sont pas affichés sur le site. Dites-nous ce que vous cherchez et nous vous contacterons.",
        "cta": "Obtenir de l'aide gratuitement",
        "modal-title": "Décrivez ce que vous cherchez",
        "modal-description": "Plus vous nous en dites, mieux nous pourrons vous aider. Seuls le nom, le courriel et le téléphone sont obligatoires.",
        "name": {
          "label": "Nom",
          "placeholder": "Votre nom"
        },
        "email": {
          "label": "Courriel",
          "placeholder": "nom{'@'}domaine.com"
        },
        "telephone": {
          "label": "Téléphone",
          "placeholder": "514 555-1234"
        },
        "search-location": {
          "label": "Où cherchez-vous?",
          "placeholder": "Ville, région ou secteur"
        },
        "property-type": {
          "label": "Type de propriété",
          "house": "Maison",
          "condo": "Condo",
          "apartment": "Appartement",
          "plex": "Plex",
          "land": "Terrain",
          "other": "Autre"
        },
        "transaction-type": {
          "label": "Transaction",
          "buy": "Acheter",
          "rent": "Louer"
        },
        "budget": {
          "label": "Budget",
          "placeholder": "ex. 400 000 $ - 500 000 $"
        },
        "bedrooms": {
          "label": "Chambres"
        },
        "bathrooms": {
          "label": "Salles de bains"
        },
        "timeline": {
          "label": "Échéancier",
          "immediately": "Immédiatement",
          "three-months": "D'ici 3 mois",
          "six-months": "D'ici 6 mois",
          "one-year": "D'ici 1 an",
          "flexible": "Flexible"
        },
        "preferred-contact": {
          "label": "Contact préféré",
          "phone": "Téléphone",
          "email": "Courriel",
          "either": "Peu importe"
        },
        "comments": {
          "label": "Commentaires",
          "placeholder": "Précisez vos besoins (stationnement, nombre d'étages, quartier, etc.)"
        },
        "consent": "J'accepte d'être contacté par Projet Habitation au sujet de ma recherche.",
        "select-default": "Non précisé",
        "cancel": "Annuler",
        "send": "Envoyer ma demande",
        "sending": "Envoi...",
        "close": "Fermer",
        "success-title": "Demande envoyée!",
        "success-message": "Merci! Notre équipe vous contactera sous peu pour vous aider dans votre recherche.",
        "privacy-consent": "En soumettant ce formulaire, j'accepte le traitement de mes données personnelles conformément à votre ",
        "privacy-policy": "politique de protection de la vie privée",
        "error": "Une erreur serveur inattendue s'est produite, veuillez réessayer plus tard.",
        "validation": {
          "name-required": "Le nom est requis.",
          "email-required": "Le courriel est requis.",
          "email-invalid": "Le courriel est invalide.",
          "telephone-required": "Le téléphone est requis.",
          "telephone-invalid": "Le téléphone est invalide.",
          "consent-required": "Votre consentement est requis.",
          "captcha-failed": "Validation humaine échouée."
        }
      }
    },
    "builders": {
      "root": {
        "title": "Constructeurs de maisons et de condos neufs au Québec {'|'} @:global.site-name",
        "header": "Constructeurs de maisons et de condos neufs au Québec",
        "intro": "Tous ces constructeurs ont au moins un projet en cours. Choisissez un type de propriété et une région pour voir qui bâtit près de chez vous.",
        "meta": {
          "description": "Découvrez les constructeurs qui ont un projet en cours au Québec, par type de propriété et par région. Maisons neuves, condos, terrains."
        },
        "loading": "Chargement des constructeurs...",
        "builders": "0 constructeur | {count} constructeur | {count} constructeurs",
        "category-summary": "{builders} dans {locations}",
        "regions": "0 région | {count} région | {count} régions",
        "directory-title": "Vous cherchez une entreprise en particulier ?",
        "directory-description": "Le répertoire réunit toutes les entreprises inscrites, tous métiers confondus, qu'elles aient un projet en cours ou non.",
        "directory-link": "Consulter le répertoire complet",
        "no-results": "Aucun constructeur n'a de projet en cours pour le moment."
      },
      "location": {
        "title": "Constructeurs {locationPhrase} : comparez {countText} de {categoryLower} {'|'} @:global.site-name",
        "title-generic": "Constructeurs de {subjectLower} {'|'} @:global.site-name",
        "header": "Constructeurs de {categoryLower} {locationPhrase}",
        "header-generic": "Constructeurs de {subjectLower}",
        "intro": "Tous ces constructeurs proposent en ce moment des {subjectLower}.",
        "meta": {
          "description": "Comparez {countText} de {categoryLower} {locationPhrase}. Consultez leurs projets en cours et trouvez le constructeur qu'il vous faut.",
          "description-generic": "Découvrez les constructeurs de {subjectLower}. Comparez leur offre et consultez leurs projets."
        },
        "builders-count": "0 constructeur | {count} constructeur | {count} constructeurs",
        "featured": "Constructeurs en vedette",
        "all": "Tous les constructeurs",
        "projects": "0 projet | {count} projet | {count} projets",
        "loading": "Chargement des constructeurs...",
        "no-results": "Aucun constructeur trouvé pour {subjectLower} pour le moment.",
        "no-logo": "Aucun logo",
        "view-builder": "Voir la fiche de {name}",
        "view-projects": "Voir les projets de {subjectLower}",
        "view-projects-unprefixed": "Voir les {subjectLower}"
      },
      "breadcrumb": {
        "home": "Accueil",
        "builders": "Constructeurs"
      }
    },
    "ad-unit": {
      "title": "Votre publicité {'|'} @:global.site-name",
      "header": "Votre publicité"
    }
  },
  "footer": {
    "tag-line": "Le site de projets de constructions neuves #1 au Québec.",
    "copyright": "Tous droits réservés.",
    "categories": {
      "projects": {
        "title": "Projets immobiliers",
        "houses-for-sale": {
          "title": "Maisons neuves à vendre",
          "category-slug": "maisons-neuves-a-vendre"
        },
        "condos-for-sale": {
          "title": "Condos neufs à vendre",
          "category-slug": "condos-neufs-a-vendre"
        },
        "condos-for-rent": {
          "title": "Condos neufs à louer",
          "category-slug": "condos-neufs-a-louer"
        }
      },
      "help": {
        "title": "Aide",
        "support": {
          "title": "Soutien"
        },
        "advertise": {
          "title": "Affichez-vous"
        }
      },
      "company": {
        "title": "Compagnie",
        "directory": {
          "title": "Répertoire"
        },
        "builders": {
          "title": "Constructeurs"
        },
        "about": {
          "title": "À propos"
        },
        "editorial": {
          "title": "Éditorial"
        },
        "guides": {
          "title": "Guides et conseils"
        }
      },
      "legal": {
        "title": "Légal",
        "privacy": {
          "title": "Confidentialité"
        },
        "terms": {
          "title": "Termes"
        }
      }
    }
  }
}
